<template>
  <fieldset :disabled="isDisabled">
    <slot />
  </fieldset>
</template>



<script>
  export default {
    name: 'FormFieldset',

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    provide() {
      const self = this;
      return {
        formFieldset: {
          get isDisabled() {
            return self.isDisabled;
          },
          get $validator() {
            return self.$validator;
          },
          get validatedForm() {
            return self.validatedForm;
          }
        }
      };
    },

    props: {
      isDisabled: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
